// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scope a white content background to this page only, mirroring the pattern
   used by WalletDetailSections (co-located global override via :has()). */
.content__wrapper:has([data-destination-retail]) {
  background-color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/pages/config/destinationRetail/styles.module.css"],"names":[],"mappings":"AAAA;0EAC0E;AAC1E;EACE,sBAAsB;AACxB","sourcesContent":["/* Scope a white content background to this page only, mirroring the pattern\n   used by WalletDetailSections (co-located global override via :has()). */\n:global(.content__wrapper):has([data-destination-retail]) {\n  background-color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
